import { imageTypes } from 'modules/proposals';

export function isImageFile(fileName: string): boolean {
  const fileExtension = `.${fileName.split('.').pop()?.toLowerCase() || ''}`;
  return Object.values(imageTypes).some((extensions) =>
    extensions.includes(fileExtension),
  );
}
